<div class="row">
  @for (item of list; track item) {
  <div class="col-lg-4 mb-4" (click)="!item?.subNav ? navigation(item, '') : false" *ngIf="item?.isShow">
    <div class="order-button">
      <div class="icon">
        <img [src]="'/assets/images/icons/' + item.icon + item.iconExt" [alt]="item.name" />
      </div>
      <h2>{{ item.name }}</h2>
      <div class="sub-items d-flex justify-content-center" *ngIf="item?.subNav">
        @for (subItem of item?.subNav; track subItem) {
          @if (!(subItem?.name == "Reserves" && storageService.userInfo?.orgUnit?.inHouseAccount)) {
              <button class="btn btn-secondary {{ subItem?.name == 'Claims Approval' ? 'claims-approval-btn' : '' }} {{ item?.name == 'Pricing' ? 'pricing-btn' : '' }}" (click)="navigation(item, subItem)">{{subItem?.name}}
                @if(item?.name == "Claims" && subItem?.name == "Claims Approval" && claimsApprovalCount !== undefined && claimsApprovalCount !== null) {
                  <span class="count-badge">{{ claimsApprovalCount > 99 ? '99+' : claimsApprovalCount }}</span>
                }
              </button>
          }
        }
    </div>
    </div>
  </div>
  }
</div>
